import { jsx as _jsx } from "react/jsx-runtime";

function SvgRadio() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("circle", {
      cx: 12,
      cy: 12,
      r: 10,
      stroke: "currentColor",
      strokeWidth: 2
    }, void 0)
  }), void 0);
}

export default SvgRadio;